/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import DesktopNavButton from './DesktopNavButton';

const DesktopMenuItem = (props) => {
  const { targetInfo, ...reset } = props;
  let active = null;
  if (targetInfo.active) {
    active = true;
  }
  return (
    <DesktopNavButton active={active} {...reset} />
  );
};
DesktopMenuItem.propTypes = {
  targetInfo: PropTypes.object,
  style: PropTypes.object,
};
DesktopMenuItem.defaultProps = {
  targetInfo: {},
  style: {},
};
export default DesktopMenuItem;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/DesktopNavigation/DesktopMenuItem.jsx